import { NewCard } from "@components/Cards/Templates/newCard";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { TenantFieldErrorMessages } from "@constants/Errors";
import {
  handleCodeChange,
  handleHiraganaKanaChange,
  handlePostCodeChange,
  phoneNumberChange,
} from "@services/ErrorHandling";
import { TENANT } from "@types/tenant";

interface TenantBasicInfoCardProps {
  tenantData: TENANT;
  updateTenantData: (key: keyof TENANT, value: string | boolean) => void;
  errors: any;
  updateError: (field: string, value: boolean) => void;
  loading: boolean;
  isAdminLoggedIn: boolean;
}

export const TenantBasicInfoCard = ({
  tenantData,
  updateTenantData,
  errors,
  updateError,
  loading,
  isAdminLoggedIn,
}: TenantBasicInfoCardProps) => {
  return (
    <NewCard
      header="基本情報"
      bodyLabel=""
      loading={loading}
      bodyContents={
        <div>
          <TextInputField
            label={"企業名"}
            placeholder="株式会社サンプル"
            required
            value={tenantData?.name}
            onChange={(e) => updateTenantData("name", e.target.value)}
          />

          <div className="mt-5 divider" />

          <TextInputField
            label={"企業名ふりがな"}
            placeholder="かぶしきがいしゃさんぷる"
            required
            value={tenantData?.name_kana}
            onChange={(e) =>
              handleHiraganaKanaChange(
                "name_kana",
                e.target.value,
                updateTenantData,
                updateError,
              )
            }
          />
          {errors.name_kana && (
            <p className="text-red-500">
              {TenantFieldErrorMessages.nameKanaError}
            </p>
          )}

          <div className="mt-5 divider" />

          <TextInputField
            label={"テナントID"}
            placeholder="sampleco"
            required
            value={tenantData?.code}
            disabled={!isAdminLoggedIn}
            onChange={(e) =>
              handleCodeChange(
                "code",
                e.target.value,
                updateTenantData,
                updateError,
              )
            }
          />
          {errors.code && (
            <p className="text-red-500">{TenantFieldErrorMessages.codeError}</p>
          )}

          <div className="mt-5 divider" />

          <TextInputField
            label={"郵便番号（ハイフンなし）"}
            placeholder="1234567"
            required
            value={tenantData?.postal_code}
            onChange={(e) =>
              handlePostCodeChange(
                "postal_code",
                e.target.value,
                updateTenantData,
                updateError,
              )
            }
          />
          {errors.postal_code && (
            <p className="text-red-500">
              {TenantFieldErrorMessages.postcodeError}
            </p>
          )}

          <div className="mt-5 divider" />

          <TextInputField
            label={"住所"}
            placeholder="東京都中央区サンプル町1-2-3"
            required
            value={tenantData?.address}
            onChange={(e) => updateTenantData("address", e.target.value)}
          />

          <div className="mt-5 divider" />

          <TextInputField
            label={"電話番号（ハイフンなし）"}
            placeholder="0312345678"
            required
            value={tenantData?.phone_number}
            onChange={(e) =>
              phoneNumberChange(
                "phone_number",
                e.target.value,
                updateTenantData,
                updateError,
              )
            }
          />
          {errors.phone_number && (
            <p className="text-red-500">
              {TenantFieldErrorMessages.telephoneNumberError}
            </p>
          )}

          <div className="mt-5 divider" />

          <TextInputField
            label="FAX番号（ハイフンなし）"
            placeholder="0312345678"
            value={tenantData?.fax_number}
            onChange={(e) =>
              phoneNumberChange(
                "fax_number",
                e.target.value,
                updateTenantData,
                updateError,
              )
            }
          />
          {errors.fax_number && (
            <p className="text-red-500">
              {TenantFieldErrorMessages.faxNumberError}
            </p>
          )}

          <div className="mt-5 divider" />

          <TextInputField
            label="企業URL"
            placeholder="example.com"
            value={tenantData?.url}
            onChange={(e) => updateTenantData("url", e.target.value.trim())}
          />
        </div>
      }
    />
  );
};
